import React, { useEffect, useState } from 'react';
import { Loader2, EyeOff } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import PersonCard from '../PersonCard';
import { adminGetUserCard } from '../../api/account';

/** Admin → Utenti: anteprima della card Persone (con audio) di un utente, anche in STANDBY. */
const AdminUserCardPreviewDialog = ({ user, open, onClose }) => {
  const [card, setCard] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open || !user) return undefined;
    let cancelled = false;
    setCard(null);
    setError('');
    adminGetUserCard(user.id)
      .then((c) => { if (!cancelled) setCard(c); })
      .catch((e) => { if (!cancelled) setError(e.response?.data?.detail || 'Impossibile caricare la card'); });
    return () => { cancelled = true; };
  }, [open, user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="admin-user-card-preview">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            Anteprima card · @{user?.username}
            {user?.standby && (
              <span className="inline-flex items-center gap-1 rounded-full bg-orange-500/20 px-2 py-0.5 text-[10px] font-bold uppercase text-orange-300">
                <EyeOff className="h-3 w-3" /> Standby
              </span>
            )}
          </DialogTitle>
        </DialogHeader>
        {user?.standby_reason && (
          <p className="text-xs text-muted-foreground" data-testid="admin-user-card-standby-reason">
            Motivo: {user.standby_reason}
          </p>
        )}
        {!card && !error && (
          <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
        )}
        {error && <p className="text-sm text-red-400" data-testid="admin-user-card-error">{error}</p>}
        {card && <PersonCard p={card} />}
        <p className="text-[11px] text-muted-foreground">
          Così la vedono gli utenti nel feed Persone. Ascolta l'audio prima di riattivare il profilo.
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default AdminUserCardPreviewDialog;
